/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { MatchMediaHOC } from 'react-match-media';
import { Configurator as ConfiguratorComponent } from '@gcc/configurator';
import finalize from '@gcc/pip-components/dist/utils/prerender/finalize';
import Toast, { notify } from '@gcc/countertops-components/dist/Toast'; // need to port
import _noop from 'lodash/noop';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import _filter from 'lodash/filter';
import { Alert } from '@one-thd/sui-atomic-components';
import _has from 'lodash/has';
import Loadable from 'react-loadable';
import { ApplyNowModal } from '@thd-olt-component-react/consumer-card-messaging';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { ThemeHomedepotcom } from '../ConfigurationSummary/index';
import { getFeatureGates } from '../../utils/featureGates';
import LoadingSpinner from '../LoadingSpinner';
import BlankLoader from '../LoadingSpinner/loaderBlank';
import BreadcrumbsLoader from '../LoadingSpinner/BreadcrumbsLoader';
import ProjectLocationLoader from '../LoadingSpinner/ProjectLocationLoader';
import ConfigLoader from '../LoadingSpinner/ConfigLoader';
import thdCustomer from '../../utils/thdCustomer';
import { partialPayStateCodes, LAMINATE_PRODUCT_ID } from '../../common/constants';
import { getEstimatedPayments } from '../../utils/thdPaymentEstimator';
import getConfiguratorSettings from '../../utils/getConfiguratorSettings';
import { createConfiguration, configuratorPricing } from './configuratorCustomApis';
import Layout from './Layout';
import { isPreviousSelectedColorEmptyOrUnavailable } from '../../utils/selectedColor-utils';
import { sizes } from '../../utils/style-utils';
import {
  ProductNotAvailableWrapper,
  Title,
  ShowConfigurator,
  HideConfigurator,
  AlertWrapper,
} from './styles';
import { trackConfiguratorPageLoad } from '../../utils/analytics';
import { getConfig } from '../../config';
import ConfigSaveFailedToast from '../notifications/ConfigSaveFailedToast';
import { QUERY_PARAM_SAMPLE_OMSID, Utils } from '../../utils/urlUtils';
import { sendAnalyticsContent } from '../../utils/analytics/sendAnalyticsContent';
import { loadPaymentEstimatorScript } from '../../utils/loadPaymentEstimatorScript';
import ColorUnavailableAlert from '../ColorUnavailableAlert/index';

const enableCecContactNumbers = getFeatureGates()?.enableCecContactNumbers;
const partialPayEnabled = getFeatureGates()?.partialPayEnabled;
const isDraft = getFeatureGates()?.isDraft;

const RailFlyout = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "railFlyout" */ '@gcc/pip-components/dist/RightRailFlyout/RightRailFlyout'
    ),
  loading: BlankLoader,
});

const Loading = Loadable({
  loader: () => import(/* webpackChunkName: "loading" */ '@gcc/pip-components/dist/LoadingSpinner'),
  loading: LoadingSpinner,
});

const Warning = Loadable({
  loader: () =>
    import(/* webpackChunkName: "warning" */ '@gcc/countertops-components/dist/Warning'), // need to port
  loading: BlankLoader,
});

const ConfigurationSummary = Loadable({
  loader: () => import(/* webpackChunkName: "configurationSummary" */ '../ConfigurationSummary'),
  loading: ConfigLoader,
});

// const Breadcrumbs = Loadable({
//  loader: () => import(/* webpackChunkName: "breadcrumbs" */ '../breadcrumbs'),
//  loading: BreadcrumbsLoader,
// });

const ProjectLocation = Loadable({
  loader: () => import(/* webpackChunkName: "projectLocation" */ '../ProjectLocation/index'),
  loading: ProjectLocationLoader,
});

const Sticky = Loadable({
  loader: () => import(/* webpackChunkName: "sticky" */ '../sticky'),
  loading: BlankLoader,
});

const ProductNotAvailable = Loadable({
  loader: () => import(/* webpackChunkName: "productNotAvailable" */ '../ProductNotAvailable'),
  loading: BlankLoader,
});

const StoreNotAvailable = Loadable({
  loader: () => import(/* webpackChunkName: "storeNotAvailable" */ '../StoreNotAvailable'),
  loading: BlankLoader,
});

const MinimumAmountModal = Loadable({
  loader: () => import(/* webpackChunkName: "minimumAmountModal" */ '../MinimumAmountModal'),
  loading: BlankLoader,
});

const MobileSummary = Loadable({
  loader: () =>
    import(/* webpackChunkName: "mobileSummary" */ './PortableDeviceLoader/MobileRendering'),
  loading: BlankLoader,
});

const DraftHeader = Loadable({
  loader: () => import(/* webpackChunkName: "stickyHeader" */ '../DraftHeader'),
  loading: BlankLoader,
});

class Configurator extends Component {
  mediaQueryList = window.matchMedia(`(max-width: ${sizes.tablet}px)`);

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      isDoneLoadingOptions: false,
      isFromSave: false,
      paymentEstimatorLoaded: false,
      manualZipCodeIsPartialPay: null,
    };
  }

  componentDidMount = () => {
    const {
      match: { omsId: parentOmsId, itemId },
      location: { search, pathname },
      history,
      storeNumber,
      getProductDetails,
      currentProducts,
      currentDesignId,
      getDesignByItem,
      persistedShapeInfo,
      loadPersistedShapes,
      updateInitialLoad,
      configServiceProps: { paymentEstimatorVersion },
      config,
    } = this.props;

    const { env, productId } = config;

    const queryStringValues = queryString.parse(search);
    const isFromSave = !!queryStringValues.save;
    const isFromSaving = !!queryStringValues.saving;
    updateInitialLoad(true);
    const isPostFormLaminate = Number(productId) === LAMINATE_PRODUCT_ID && window?.injectedConfiguratorSettings?.laminatePostFormFeatureGate;

    const omsId = queryStringValues.draftProductId || parentOmsId;
    if (_has(queryStringValues, QUERY_PARAM_SAMPLE_OMSID)) {
      history.replace(`${pathname}${Utils.deleteQueryParam(env.search, QUERY_PARAM_SAMPLE_OMSID)}`);
    }

    if (!currentDesignId && itemId) {
      getDesignByItem(itemId, isFromSave, isFromSaving, isPostFormLaminate).then(() => {
        if (isFromSave || queryStringValues.success) {
          this.setState({ isFromSave });
          history.replace(`${pathname}${Utils.deleteQueryParam(env.search, 'save')}`);
        }
        if (isFromSaving) {
          history.replace(`${pathname}${Utils.deleteQueryParam(env.search, 'saving')}`);
        }
      });
    } else if (!(currentProducts && currentProducts[omsId] && !_isEmpty(currentProducts[omsId]))) {
      getProductDetails({ omsId, productId: omsId, storeNumber, isPostFormLaminate });
    }

    const queryParams = new URLSearchParams(window.location.search);
    const isPersistedShapeInfo = queryParams.get('persistedShapeInfo');
    const currentState = window.history.state;

    if (isPersistedShapeInfo || currentState?.persistedShapeInfo) {
      loadPersistedShapes(omsId);
    } else {
      persistedShapeInfo();
    }
    loadPaymentEstimatorScript(paymentEstimatorVersion, () =>
      this.setState({ paymentEstimatorLoaded: true })
    );
    if (ConfigurationSummary || MobileSummary) {
      const module = {
        name: 'right rail',
        feature: 'plcc',
        type: 'cta',
      };
      sendAnalyticsContent(module);
    }

    this.handleMediaChange();
    this.mediaQueryList.addListener(this.handleMediaChange);
  };

  componentDidUpdate = (prev) => {
    const LPM = document.body.getElementsByClassName('LPMcontainer');
    if (LPM.length > 0) {
      LPM[0].style.display = 'none';
      LPM[0].style.visibility = 'hidden';
    }
    const {
      isConfiguratorLoading,
      savedProductChoices,
      enableSave,
      selectedColorPrice,
      disableSave,
      currentDesignId,
      price,
    } = this.props;
    const { isDoneLoadingOptions } = this.state;

    if (window.prerender && !isConfiguratorLoading && prev.isConfiguratorLoading) {
      finalize();
    }
    if (!selectedColorPrice) {
      disableSave();
    } else {
      if (
        (isDoneLoadingOptions && !_isEqual(prev.savedProductChoices, savedProductChoices)) ||
        selectedColorPrice
      ) {
        enableSave();
      }
      if (currentDesignId && price.price > 0) {
        enableSave();
      }

    }
  };

  handleMediaChange = () => {
    this.setState({ isMobile: this.mediaQueryList.matches });
  };

  handleManualZipCodeIsPartialPay = (showPartialPayAlert) => {
    this.setState({ manualZipCodeIsPartialPay: showPartialPayAlert });
  };

  isConfiguratorReady = () => {
    const { match, currentItem, currentDesignId } = this.props;
    const { itemId } = match;
    const configGuid =
      currentItem &&
      currentItem.itemId &&
      currentItem.itemProduct &&
      currentItem.itemProduct.configurationGuid;
    return {
      loadConfigurator: itemId ? currentDesignId && currentItem.itemId : true,
      configurationId: configGuid,
    };
  };

  saveSuccess = (configurationGuid) => {
    const {
      onSaveSuccess,
      currentDesignId,
      currentItem: { itemId },
      disableSave,
      history,
      location: { pathname },
      match: { omsId },
      location: { search },
      designAssociated,
    } = this.props;
    const { isFromSave } = this.state;
    const env = getConfig()?.env;
    onSaveSuccess(currentDesignId, itemId, configurationGuid)
      .then(() => {
        disableSave();
        const queryStringWithSaving = env.search ? `${env.search}&saving=1` : '?saving=1';
        if (pathname.indexOf(itemId) < 0 && itemId) {
          if (thdCustomer.isLoggedIn || designAssociated) {
            history.replace(
              `${pathname.substring(0, pathname.indexOf(omsId) + omsId.length)}/item/${itemId}${
                env.search
              }`
            );
          } else {
            history.replace(
              `${pathname.substring(
                0,
                pathname.indexOf(omsId) + omsId.length
              )}/item/${itemId}${queryStringWithSaving}`
            );
          }
        } else if (!designAssociated && !thdCustomer.isLoggedIn && !isFromSave) {
          history.replace(
            `${pathname.substring(
              0,
              pathname.indexOf(omsId) + omsId.length
            )}/item/${itemId}${queryStringWithSaving}`
          );
        }
      })
      .catch((err) => {
        notify(
          ConfigSaveFailedToast(() => this.saveSuccess(configurationGuid)),
          0
        );
      });
  };

  render() {
    const {
      match,
      onLoadSuccess,
      onLoadFailure,
      sku,
      siteId,
      zipCode,
      draftingTool,
      areaChanged,
      initialLoad,
      isLoading,
      priceLoading,
      configurationImageUrl,
      hasQuote,
      storeNumber,
      isConfiguratorLoading,
      isProductAvailable,
      productName,
      breadcrumbs,
      disableSave,
      availableSkus,
      isStoreEnabled,
      storeInfo,
      isSaving,
      saveFailed,
      currentColor,
      isSelectionAvailable,
      pcpSupportPhoneNumber,
      showModal,
      togglePlccModal,
      selectedColor,
      price,
      location: { search },
      configurationIdForSelections,
      alertBannerText,
      countertopsBaseUrl,
      choices,
    } = this.props;
    const config = getConfig();

    const { isMobile, paymentEstimatorLoaded, manualZipCodeIsPartialPay } = this.state;
    const { omsId: parentOmsId } = match;

    const queryStringValues = queryString.parse(search);
    const omsId = queryStringValues.draftProductId || parentOmsId;

    const priceCheck = price?.strikeThroughPrice?.hasStrikeThroughPricing
      ? price?.strikeThroughPrice?.price
      : price?.price;

    const updatedPrice = Math.floor(priceCheck);

    const nonZeroPricedChoices = _filter(choices, (cc) => Number(cc.price) > 0);

    const showColorUnavailableAlert = isPreviousSelectedColorEmptyOrUnavailable(selectedColor, nonZeroPricedChoices);

    const { loadConfigurator, configurationId } = this.isConfiguratorReady();
    const closeModal = () => {
      togglePlccModal(false);
    };
    const defaultApplyNowLink =
      'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL' +
      '&siteId=PLCN_HOMEDEPOT&sc=30005&cmp=A~P~7~J~A~C~ZZZ0~AI~HD~ZZ_1D3';

    const defaultApplyNowLinkMobile =
      'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL' +
      '&siteId=PLCN_HOMEDEPOT&sc=30005&cmp=C~P~7~J~A~C~ZZZ0~AI~HD~ZZ_1D3';

    const configuratorSettings = {
      ...getConfiguratorSettings(config),
      onLoadSuccess: () => {
        onLoadSuccess().then(() => {
          // eslint-disable-next-line no-console
          console.info('Configurator loaded succesfully!');
          this.setState({ isDoneLoadingOptions: true }, () => {
            const { isFromSave } = this.state;
            if (isFromSave) {
              this.saveSuccess(configurationId);
              disableSave();
            }
          });
        });
        if (!isDraft) {
          trackConfiguratorPageLoad(omsId, config?.omnitureInfo);
        }
      },
      onLoadFailure: () => {
        // eslint-disable-next-line no-console
        console.error('Configurator failed to load!');
        onLoadFailure();
      },
      onSaveSuccess: ({ configurationGuid }) => {
        this.saveSuccess(configurationGuid);
      },
      customValidators: {
        WindowName: (optionData) => {
          if (!optionData.optionChoice) {
            return [];
          }
          if (!optionData.optionChoice.value.length) {
            return [
              {
                message: 'Oops!  Looks like you missed a step',
                messageType: 'Error',
              },
            ];
          }

          return [];
        },
      },
      createConfigurationApi: ({ selections, productId: configProductId }) =>
        createConfiguration(
          selections,
          configProductId,
          siteId,
          zipCode,
          draftingTool,
          configurationImageUrl,
          sku
        ),
      priceApi: (data) => configuratorPricing(data, storeNumber, sku), // TODO use this pricing for PIP
      onSaveFailure: (data, message) => {
        saveFailed();
        // eslint-disable-next-line no-console
        console.error('Save Failed!');
        // eslint-disable-next-line no-console
        console.log(message);
        // eslint-disable-next-line no-console
        console.debug(data);
      },
    };

    configuratorSettings.productId = omsId;
    if (storeNumber && sku) {
      // eslint-disable-next-line max-len
      configuratorSettings.getOptionsApi = `${config?.customBaseUrl}/countertops/api/configuratoroptions/${storeNumber}/${sku}?availableSkus=${availableSkus}`;
      if (configurationIdForSelections !== undefined) {
        configuratorSettings.getOptionsApi = `${configuratorSettings.getOptionsApi}&configurationIdForSelections=${configurationIdForSelections}`;
      }
    }
    if (configurationId) {
      configuratorSettings.configurationId = configurationId;
    }

    const ConfigurationSummaryDesktop = MatchMediaHOC(
      ConfigurationSummary,
      'not all and (max-width: 1024px)'
    );
    const showWarning =
      initialLoad || isLoading || !priceLoading || initialLoad === undefined
        ? true
        : isSelectionAvailable;
    const checkWarning = !!(areaChanged === (true || undefined) || showWarning === true);

    const showPartialPayAlert =
      manualZipCodeIsPartialPay ?? partialPayStateCodes.includes(storeInfo?.address?.state);

    const plccPromotion = getEstimatedPayments(updatedPrice);

    return (
      <>
        <div id="configuratorWrapper">
          {showColorUnavailableAlert && !initialLoad && (
            <ColorUnavailableAlert />
          )}
          <ErrorBoundary name="toast">
            <Toast />
          </ErrorBoundary>
          {enableCecContactNumbers && (
            <ErrorBoundary name="rail-flyout">
              <RailFlyout contactNumber={pcpSupportPhoneNumber} />
            </ErrorBoundary>
          )}
          <ErrorBoundary name="minimum-amount-modal">
            <MinimumAmountModal />
          </ErrorBoundary>
          <ErrorBoundary name="loading">
            <Loading isLoading={isConfiguratorLoading || isSaving} />
          </ErrorBoundary>
          {isDraft ? (
            <ErrorBoundary name="draft-header">
              <DraftHeader />
            </ErrorBoundary>
          ) : null}
          <div style={isConfiguratorLoading ? { opacity: '0.5' } : { opacity: '1' }}>
            {showWarning && currentColor && (
              <ErrorBoundary name="warning">
                <Sticky top={10} bottomBoundary={50000} innerZ={99} enabled>
                  <Warning
                    fromSite="dotcom"
                    isSelectionAvailable={showWarning}
                    checkWarning={checkWarning}
                    colorSelected={currentColor}
                  />
                </Sticky>
              </ErrorBoundary>
            )}
            {plccPromotion && showModal && (
              <ErrorBoundary name="apply-now-modal">
                <ApplyNowModal
                  closeModal={closeModal}
                  analyticsFeature="plcc-apply now"
                  isMobile={isMobile}
                  price={updatedPrice}
                  monthlyPayment={plccPromotion?.monthlyPayment}
                  promotionTerm={plccPromotion?.promotionTerm}
                  applyNowUrl={isMobile ? defaultApplyNowLinkMobile : defaultApplyNowLink}
                />
              </ErrorBoundary>
            )}
            <div className="options">
              <div className="countertops">
                <>
                  <QueryProvider cacheKey="breadcrumbs">
                    <ErrorBoundary name="breadcrumbs">
                      <Breadcrumbs itemId={omsId} useStencilDesign />
                    </ErrorBoundary>
                  </QueryProvider>
                  {showPartialPayAlert && partialPayEnabled && (
                    <AlertWrapper>
                      <Alert status="info">{alertBannerText}</Alert>
                    </AlertWrapper>
                  )}
                  <div className="location-customize-background">
                    <Title className="sui-h1-bold">
                      {`Customize Your ${productName
                        .trim()
                        .replace(/(^custom)/gi, '')
                        .trim()}`}
                    </Title>
                    <ErrorBoundary name="project-location">
                      <ProjectLocation
                        lockLocation={hasQuote}
                        contactNumber={pcpSupportPhoneNumber}
                        handleManualZipCodeIsPartialPay={this.handleManualZipCodeIsPartialPay}
                        path="design"
                        countertopsBaseUrl={countertopsBaseUrl}
                      />
                    </ErrorBoundary>
                    {!isStoreEnabled && (
                      <ErrorBoundary name="store-not-available">
                        <StoreNotAvailable
                          thdDepartmentNumber={getConfig()?.thdDepartmentNumber}
                          thdProductTypeId={getConfig()?.thdProductTypeId}
                        />
                      </ErrorBoundary>
                    )}
                  </div>
                  {isProductAvailable && loadConfigurator && sku ? (
                    <div style={!isStoreEnabled ? HideConfigurator : ShowConfigurator}>
                      <ErrorBoundary name="configurator-component">
                        <ConfiguratorComponent settings={configuratorSettings}>
                          <Layout isMobile={isMobile && (isConfiguratorLoading || isSaving)} />
                        </ConfiguratorComponent>
                      </ErrorBoundary>
                    </div>
                  ) : (
                    <div>
                      {isStoreEnabled && !isProductAvailable && !isConfiguratorLoading && (
                        <ProductNotAvailableWrapper>
                          <ErrorBoundary name="product-not-available">
                            <ProductNotAvailable />
                          </ErrorBoundary>
                        </ProductNotAvailableWrapper>
                      )}
                    </div>
                  )}
                </>
              </div>
              {!isMobile && (
                <ErrorBoundary name="summary-desktop">
                  <Sticky
                    component="summary"
                    bottomBoundary={6600}
                    enabled={isProductAvailable && isStoreEnabled}
                  >
                    <div id="summary-desktop" className="summary-desktop">
                      <ThemeHomedepotcom>
                        <ConfigurationSummaryDesktop
                          omsId={omsId}
                          plccPromotion={plccPromotion}
                          enableCecContactNumbers={enableCecContactNumbers}
                          contactNumber={pcpSupportPhoneNumber}
                          showPlccModal={togglePlccModal}
                          withApplyNow
                          isConfiguratorLoading={isConfiguratorLoading}
                        />
                      </ThemeHomedepotcom>
                    </div>
                  </Sticky>
                </ErrorBoundary>
              )}
            </div>
          </div>
        </div>
        {isMobile && (
          <ErrorBoundary name="mobile-summary">
            <MobileSummary
              omsId={omsId}
              plccPromotion={plccPromotion}
              showPlccModal={togglePlccModal}
            />
          </ErrorBoundary>
        )}
      </>
    );
  }
}

Configurator.propTypes = {
  match: PropTypes.object.isRequired, // router
  location: PropTypes.object.isRequired, // router
  history: PropTypes.object.isRequired, // router
  onLoadSuccess: PropTypes.func,
  onLoadFailure: PropTypes.func,
  onSaveSuccess: PropTypes.func,
  sku: PropTypes.number,
  siteId: PropTypes.number,
  zipCode: PropTypes.string,
  draftingTool: PropTypes.object.isRequired,
  areaChanged: PropTypes.bool,
  initialLoad: PropTypes.bool,
  configurationImageUrl: PropTypes.string,
  currentItem: PropTypes.object,
  currentDesignId: PropTypes.string,
  hasQuote: PropTypes.bool,
  isConfiguratorLoading: PropTypes.bool.isRequired,
  storeNumber: PropTypes.number.isRequired,
  storeInfo: PropTypes.shape({
    address: PropTypes.shape({
      state: PropTypes.string,
    }),
  }),
  getProductDetails: PropTypes.func.isRequired,
  currentProducts: PropTypes.object,
  getDesignByItem: PropTypes.func.isRequired,
  disableSave: PropTypes.func.isRequired,
  enableSave: PropTypes.func.isRequired,
  isProductAvailable: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  priceLoading: PropTypes.bool.isRequired,
  productName: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf([]),
  savedProductChoices: PropTypes.object.isRequired,
  availableSkus: PropTypes.string,
  isStoreEnabled: PropTypes.bool,
  isSaving: PropTypes.bool,
  saveFailed: PropTypes.func,
  designAssociated: PropTypes.bool,
  currentColor: PropTypes.string,
  configServiceProps: PropTypes.object.isRequired,
  isSelectionAvailable: PropTypes.bool.isRequired,
  pcpSupportPhoneNumber: PropTypes.string.isRequired,
  persistedShapeInfo: PropTypes.func,
  loadPersistedShapes: PropTypes.func,
  updateInitialLoad: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  togglePlccModal: PropTypes.func.isRequired,
  price: PropTypes.shape({
    price: PropTypes.number,
    strikeThroughPrice: PropTypes.shape({
      hasStrikeThroughPricing: PropTypes.bool,
      price: PropTypes.number,
    }),
  }).isRequired,
  configurationIdForSelections: PropTypes.string,
  selectedColorPrice: PropTypes.string,
  config: PropTypes.shape({
    env: PropTypes.shape({
      search: PropTypes.string,
    }),
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  alertBannerText: PropTypes.string,
  countertopsBaseUrl: PropTypes.string.isRequired,
};

Configurator.defaultProps = {
  onLoadSuccess: _noop,
  onLoadFailure: _noop,
  onSaveSuccess: _noop,
  persistedShapeInfo: _noop,
  loadPersistedShapes: _noop,
  areaChanged: undefined,
  siteId: 11,
  zipCode: '',
  configurationImageUrl: undefined,
  currentItem: undefined,
  currentColor: undefined,
  currentDesignId: undefined,
  initialLoad: undefined,
  breadcrumbs: undefined,
  selectedColorPrice: undefined,
  storeInfo: null,
  hasQuote: false,
  currentProducts: {},
  isProductAvailable: true,
  sku: null,
  availableSkus: null,
  isStoreEnabled: true,
  isSaving: false,
  saveFailed: _noop,
  designAssociated: false,
  configurationIdForSelections: undefined,
  config: {},
  alertBannerText:
    'Based on your installation location you may only be responsible for paying an initial deposit to checkout. This will be determined at checkout. The remaining balance will be collected at a later date.',
};

export default Configurator;
